import {event} from '../modules/event';

/* DEPRECATED */
/* использовалось для правоц колонки */

var rightContent = function(wrapper){
    var mainWrapper =  document.getElementById('main-frame'),
        leftWrapper = document.getElementById('main-left'),
        rightWrapper = document.getElementById('main-right'),
        firstWrapper = rightWrapper.querySelector('[data-rightContent="first"]'),
        secondWrapper = rightWrapper.querySelector('[data-rightContent="second"]'),
        getHeight = function(el){
            var box = el.getBoundingClientRect();
            return box.bottom - box.top;
        },
        leftWrapperHeight = getHeight(leftWrapper),
        rightWrapperHeight = getHeight(rightWrapper),
        clearAdd,
        add = function(){
            try{clearTimeout(clearAdd)} catch(e){}
            clearAdd = setTimeout(function(){
                //checkFixed
                var top = leftWrapper.getBoundingClientRect().top;
                var newScrollTop = window.pageYOffset || document.documentElement.scrollTop - top;

                if(top < 0){
                    if(rightWrapper.className.indexOf('js-fixed') === -1) rightWrapper.className = rightWrapper.className + ' js-fixed';

                    //checkMiddle
                    var middle =  (leftWrapperHeight - rightWrapperHeight) / 2;

                    if(-top < leftWrapperHeight/2) {
                        if(firstWrapper.className.indexOf('js-active') === -1)  firstWrapper.className = firstWrapper.className + ' js-active';
                        if(secondWrapper.className.indexOf('js-active') !== -1)  secondWrapper.className = secondWrapper.className.replace(/\s*js-active/, '');
                    }
                    else {
                        if(secondWrapper.className.indexOf('js-active') === -1)  secondWrapper.className = secondWrapper.className + ' js-active';
                        if(firstWrapper.className.indexOf('js-active') !== -1)  firstWrapper.className = firstWrapper.className.replace(/\s*js-active/, '');
                    }
                }
                else{
                    if(rightWrapper.className.indexOf('js-fixed') !== -1){
                        rightWrapper.className = rightWrapper.className.replace(/ js-fixed/, '');
                    }
                    if(firstWrapper.className.indexOf('js-active') === -1)  firstWrapper.className = firstWrapper.className + ' js-active';
                    if(secondWrapper.className.indexOf('js-active') !== -1)  secondWrapper.className = secondWrapper.className.replace(/\s*js-active/, '');
                }
            }, 0);
        };

    setTimeout(function(){
        if(!addEventListener) return false;

        addResizeListener(mainWrapper, function(){
            leftWrapperHeight = getHeight(leftWrapper);
            add();
        });

        event.add(window, 'resize', function(){
            rightWrapperHeight = getHeight(rightWrapper);
            add();
        });

        event.add(window, 'scroll', function(){
            add();
        });

        add();
    }, 0);
};

export {rightContent};

































